import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import { applicationStore } from "src/store/ApplicationStore";
import SelectCountryForm from "src/components/select-country";
import { fetchForIdVerification } from "src/services/fetchModelsServices";
import logger from "src/utils/logger";

const SelectCountry = observer(() => {
  const navigate = useNavigate();
  const workflowResponse = applicationStore.workflowNextServiceResponse;

  const idType = useMemo(() => {
    return workflowResponse?.id_type === "company" ? "kyb" : "kyc";
  }, [workflowResponse]);

  const selectedCountries = workflowResponse?.node_settings?.selectedCountries || null;

  const handleSubmit = async (selectedCountry) => {
    if (!selectedCountry) {
      return;
    }

    try {
      applicationStore.setCountry(selectedCountry.value.toLowerCase());
      applicationStore.setConditionContext({ country: selectedCountry.value });

      if (workflowResponse?.verification) {
        fetchForIdVerification(selectedCountry.value.toLowerCase());
      }

      navigate("/next", { replace: true });
    } catch (error) {
      logger.log(error);
    }
  };

  const handleBack = () => {
    navigate(`/?aid=${applicationStore.aidCode}`, {
      replace: true,
    });
  };

  return (
    <div className="custom-container">
      <SelectCountryForm
        idType={idType}
        onBack={handleBack}
        onSubmit={handleSubmit}
        initialCountryCode={
          applicationStore.country
            ? applicationStore.country.toUpperCase()
            : workflowResponse?.country || null
        }
        selectedCountries={selectedCountries}
      />
    </div>
  );
});

export default SelectCountry;
